export const PAYMENT_ROUTE = '/pay';
export const PAYMENT_ERROR_ROUTE = '/payment-error';
export const PAYMENT_SUCCESS_ROUTE = '/payment-success';
export const PAYMENT_IN_PROGRESS_ROUTE = '/payment-in-progress';
export const CLIENT_ORDER_ROUTE = '/client-order';
